export default __webpack_public_path__ + "181ee14a80d4f23de7b85c105203328b.pdf";